import * as React from 'react';
import { RatingsRedesigned } from '../../components/RatingsRedesigned';
import { useSelector } from 'react-redux';
import { getReviewsStats } from '../../selectors/developerV2';

export const Ratings = () => {
  const { reviewCountText, totalRate, reviewCount } = useSelector(getReviewsStats);

  // TODO Добавить скролл на блок отзывов в CD-209590
  /* istanbul ignore next */
  const onClick = () => {};

  return (
    <RatingsRedesigned
      onClick={onClick}
      reviewCountText={reviewCountText}
      totalRate={totalRate}
      reviewCount={reviewCount}
    />
  );
};
